<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>角色管理</p>
          <div class="btnBox" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('4-1')>-1">
            <button class="btn btn-add" @click="addType='add';">新增角色</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.level_name">{{item.level_name}}</p>
              <p :title="item.authority">
                <span v-for="(ele,num) in item.authority" v-bind:key="num">{{ele}}</span>
              </p>
              <p >
                <span style="color:#FF7543;" @click="authorityShow(item)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('4-2')>-1">权限配置</span>
                <span style="color:#FF5156;" @click="removeShow(item)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('4-3')>-1">删除</span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 权限配置提示框 -->
    <div class="msgBox tipsBox authorityBox" v-if="addType">
      <div class="contv">
        <p class="title">{{addType=='add'?'新增角色':'权限配置'}}</p>
        <div class="scroll">
          <div class="write" v-if="addType=='add'">
            <p>新增角色</p>
            <form>
              <div class="write-txt">
                <p>角色名称:</p>
                <input type="text" v-model="addObj.level_name">
              </div>
            </form>
          </div>
          <div class="list">
            <p class="list-title">权限配置</p>
            <div class="first" v-for="item in authorityList" v-bind:key="item.id">
              <p class="first-title">{{item.title}}</p>
              <div class="second">
                <div class="second-title" v-for="ele in item.children" v-bind:key="ele.id">
                  <label>
                    <input type="checkbox" v-model="ele.check" :value="ele.id">
                    <p>{{ele.title}}</p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btnBox">
          <button class="btn btn-sub" @click="authoritySub">{{addType=='add'?'添加':'修改'}}</button>
          <button class="btn btn-close" @click="authorityHide">取消</button>
        </div>
      </div>
    </div>

    <!-- 删除提示框 -->
    <div class="msgBox removeBox " v-if='removeType'>
      <div class="contv">
        <p class="title">提示</p>
        <p class="txt">确认删除吗？</p>
        <div class="btnBox">
          <button class="btn btn-remove" @click="removeSub">删除</button>
          <button class="btn btn-close" @click="removeType=false;">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { addRole,getRoleList,getRoleAuthority,setRoleAuthority,delRole } from "@/assets/js/api";
export default {
  name: "topic-config",
  data() {
    return {
      navId:'5',
      childrenID:'5-2',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'角色名称'},
        {id:3,title:'权限'},
        {id:4,title:'操作'},
      ],
      dataList:[],
      addType:'',
      authorityList:[
        {id:'1-1',title:'证书类型设置',children:[
            {id:'1-1-1',title:'添加类型',check:false,disabled:true},
            {id:'1-1-2',title:'编辑类型',check:false,disabled:true},
          ]
        },
        {id:'1-2',title:'证书列表',children:[
            {id:'1-2-1',title:'添加证书',check:false,disabled:true},
            {id:'1-2-2',title:'查看题库',check:false,disabled:true},
            {id:'1-2-3',title:'查看学员',check:false,disabled:true},
            {id:'1-2-4',title:'配置',check:false,disabled:true},
            {id:'1-2-5',title:'编辑证书',check:false,disabled:true},
            {id:'1-2-6',title:'发布',check:false,disabled:true},
          ]
        },
        {id:2,title:'学员管理',children:[
          {id:'2-1',title:'导入学员/添加学员',check:false,disabled:true},
          {id:'2-2',title:'编辑学员',check:false,disabled:true},
          {id:'2-3',title:'注销学员',check:false,disabled:true},
        ]},
        {id:3,title:'后台账号管理',children:[
          {id:'3-1',title:'添加账号',check:false,disabled:true},
          {id:'3-2',title:'修改信息',check:false,disabled:true},
          {id:'3-3',title:'权限配置',check:false,disabled:true},
          {id:'3-4',title:'注销账号',check:false,disabled:true},
        ]},
        {id:4,title:'角色管理',children:[
          {id:'4-1',title:'新增角色',check:false,disabled:true},
          {id:'4-2',title:'权限配置',check:false,disabled:true},
          {id:'4-3',title:'删除账号',check:false,disabled:true},
        ]},
        {id:5,title:'题型配置',children:[
          {id:'5-1',title:'编辑题型',check:false,disabled:true},
        ]},
      ],
      addType:false,
      removeType:false,
      token:'',
      addObj:{
        level_name:'',
        authority:[],
      },
      obj:{
        page:1,
        rows:10
      },
      totalPage:0,
      userid:'',
      userData:{
        authority:[],
      },
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    authoritySub(e){
      var that = this;
      this.authorityList.forEach(function(item,index){
        item.children.forEach(function(ele,num){
          if(ele.check){
            that.addObj.authority.push(ele.id);
          }
        })
      });

      if(this.addType == 'add'){
        that.addObj.type = '4-1';
        addRole(that.addObj,that.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.$message('添加成功！');
            that.page = 1;
            that.getList();
            that.authorityHide();
          } else {
            that.$message(data.msg);
          }
        })
      } else {
        var obj = {
          id:that.userid,
          authority:that.addObj.authority,
          type:'4-2'
        };
        setRoleAuthority(obj,that.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.$message('修改成功！');
            that.page = 1;
            that.getList();
            that.authorityHide();
          } else {
            that.$message(data.msg);
          }
        })
      }
      
    },

    authorityHide(){
      var that = this;
      that.addType = '';
      that.addObj = {
        level_name:'',
        authority:[],
      };
    },

    getList(){
      var that = this;
      getRoleList(that.obj,that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          var list = data.data.list;
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
          data.data.list.forEach(function(item,index){
            var list1 = [];
            item.authority.forEach(function(ele,num){
              that.authorityList.forEach(function(i,k){
                i.children.forEach(function(j,l){
                  if(ele == j.id){
                    list1.push(j.title);
                    item.authority = list1;
                  };
                })
              })
            })
          });
        } else {
          that.$message(data.msg);
        }
      })
    },

    authorityShow(e){
      var that = this;
      this.userid = e.id;
      getRoleAuthority({id:e.id},that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          data.data.authority.forEach(function(item,index){
            that.authorityList.forEach(function(ele,num){
              ele.children.forEach(function(i,k){
                if(item == i.id){
                  i.check = true;
                }
              })
            })
          });
          that.addType='authority';
        } else {
          that.$message(data.msg);
        }
      })
    },

    removeShow(e){
      this.userid = e.id;
      this.removeType = true;
    },

    removeSub(){
      var that = this;
      delRole({id:that.userid,type:'4-3'},that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('删除成功！');
          that.page = 1;
          that.getList();
          that.removeType = false;
        } else {
          that.$message(data.msg);
        }
      })
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: 25%;
}

.organiza-txt{
  height: calc(100% - 120px);
}

.dataList .listItem p span{
    margin: 0 10px 0 0;
}

.authorityBox .contv{
  height: 80%;
}

.authorityBox .scroll{
  height: calc( 100% - 140px );
  overflow-y: auto;
  overflow-x: hidden;
}

.authorityBox .list{
  font-size: 0;
  text-align: left;
  width: 100%;
  padding: 0 20px;
}

.authorityBox .list .first{
  margin-bottom: 20px;
}

.authorityBox .list .first-title{
  font-size: 16px;
  color: #457AFF;
  line-height: 30px;
  height: 30px;
}

.authorityBox .list .second {
  margin-top: 12px;
}

.authorityBox .list .second-title {
  display: inline-block;
  vertical-align: top;
  margin-right: 20px;
}

.authorityBox .list .second-title label{
}

.authorityBox .list .second-title label input{
  widows: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: top;
}

.authorityBox .list .second-title p{
  font-size: 16px;
  color: #3D3D3D;
  display: inline-block;
  vertical-align: top;
}

.authorityBox .write-txt{
  text-align: left;
  padding: 0 20px;
}

.authorityBox .btnBox{
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/admin/user.vue